module.exports = __webpack_public_path__ + "img/3pica.9638bf9f.png";